import { Address, ADDRESS_TEMPLATE } from "./address";
import { DtacBase } from "./dtac-base";

export interface Location extends DtacBase {
  address: Address;
  locationCode: string;
  locationName: string;
};

export const LOCATION_TEMPLATE: Location = {
  '@id': '',
  '@type': '',
  address: ADDRESS_TEMPLATE,
  locationCode: '',
  locationName: ''
};
